import React from "react"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"
import { CustomDialog } from "../../molecules/Dialog/CustomDialog"
import CustomDialogHead from "../../molecules/Dialog/CustomDialogHead"
import { FaqItem } from "./types"

interface Props {
  item?: FaqItem
  open: boolean
  onClose?: () => void
}

const FaqContentDialog = ({ item, open, onClose }: Props) => {
  return (
    <CustomDialog
      open={open && item !== undefined}
      onClose={onClose}
      openDirection="right"
      fullScreen
    >
      <CustomDialogHead
        closePosition="left"
        closeControl="back"
        onClose={onClose}
      />
      <div className="px-2 pt-4">
        <TwRichTextField variant="h5" value={item?.title} />
        <div className="my-3">
          <TwRichTextField fillLine value={item?.content} />
        </div>
      </div>
    </CustomDialog>
  )
}

export default FaqContentDialog
